import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetListSurveys = (id, surveyId) => {
  const endpoint = id
    ? `/SurveyController/GetSurverListByUser?userId=${id}${surveyId ? `&surveyId=${surveyId}` : ""}`
    : `/SurveyController/GetSurveyList`;

  return useQuery(
    [id ? "GetSurverListByUser" : "getSurveys"],
    () => axiosClient.post(endpoint)
  );
};

export default useGetListSurveys;
